class QFCustomFilter {

    constructor(settings = {}){
  
        // init element classes
        this.container = settings.container ? settings.container : "post-container";
        this.item = settings.item ? settings.item : "post";
        this.itemID = settings.itemID  ? settings.itemID : "data-post-id";
        this.noPosts = settings.noPosts ? settings.noPosts : "custom-filter-no-posts";
        this.loadMore = settings.loadMore ? settings.loadMore : "custom-filter-load-more";
        this.filterContainer = settings.filterContainer ? settings.filterContainer : "filter-container";
        this.sortContainer = settings.sortContainer ?  settings.sortContainer : "sort-container"
  
        // get element ref
        this.containerEl = document.querySelector(`.${this.container}`)
        this.loadMoreEl = document.querySelector(`.${this.loadMore}`)
        this.noPostsEl = document.querySelector(`.${this.noPosts}`)
        this.filterContainerEl = document.querySelector(`.${this.filterContainer}`)
        this.sortContainerEl = document.querySelector(`.${this.sortContainer}`)
  
        // get formatted post data
        this.postData  = settings.postData ? settings.postData : {};
  
        // get filtter settings
        this.filterSettings = settings.filterSettings ? settings.filterSettings : {};
  
        // get post limits
        this.postsToShow = settings.postsToShow ? settings.postsToShow : 10;
        this.loadMoretoShow = settings.loadMoretoShow ? settings.loadMoretoShow : 12;
  
        // get additional options
        this.buildFilters = settings.buildFilters == 'false' ? false : true;
        this.ignoreFilters = settings.ignoreFilters ? settings.ignoreFilters : [];
  
  
        // set price range
        this.defaultMinPrice = 0;
        this.defaultMaxPrice = Number.MAX_SAFE_INTEGER;
        this.minPrice = this.defaultMinPrice;
        this.maxPrice = this.defaultMaxPrice;
  
        // Advert
        this.advertHtml = null;
  
  
  
        this.filterOptions = {};
        this.allPostHtml = {};
        this.currentPostHtml = {};
        this.allowedSortMethods = [
            'default',
            'title_asc',
            'title_dsc',
            'published_at_asc',
            'published_at_dsc',
            'price_asc',
            'price_dsc',
        ]
  
  
        this.sortMethod = 'default';
  
  
        this.init()
  
    }
  
      init(){
          //window.log(`postData:`, this.postData)
  
          this.buildAdditionalElements()
          this.setAdvert()
          this.setAdvertVideo()
          this.storePostHtml()
          if(this.buildFilters){ this.buildFiltersFunction() }
          this.urlFilters()
          this.setUpListeners()
  
          this.showPosts();
  
          let wrapper = document.getElementById("qf-filter-wrapper")
          if(wrapper){
              window.log("WINDOW")
              wrapper.style.overflow = 'unset'
              wrapper.style.maxHeight = 'unset'
          }
  
          let filter_initialised = new CustomEvent('filter_initialised', {
              detail : {}
          });
  
          window.dispatchEvent(filter_initialised);
  
      }
  
      buildAdditionalElements() {
          //window.log(">>>>>>>>>>> QFCustomFilter")
  
          // check for no container element
          if(!this.containerEl){
              window.log(`%cQFCustomFilter: ERROR - No element with class ${this.container} found. Please ensure the element exists.`, 'color: red; background: black; padding: 6px;')
              return false;
          }
  
          // check for load more element
          if(!this.loadMoreEl){
              window.log(`%cQFCustomFilter: WARNING - No element with class ${this.loadMore} found. All posts will be shown be default.`, 'color: orange; background: linear-gradient(45deg, rgba(28,87,126,1) 0%, rgba(70,54,122,1) 100%); padding: 6px;')
              this.postsToShow = Number.MAX_SAFE_INTEGER // if no load more exists show all posts by default
          }
  
          // check for no posts element
          if(!this.noPostsEl){
              window.log(`%cQFCustomFilter: WARNING - No element with class ${this.noPosts} found. No message will be shown when search criteria returns no results.`, 'color: orange; background: linear-gradient(45deg, rgba(28,87,126,1) 0%, rgba(70,54,122,1) 100%); padding: 6px;')
          } else {
              // hide no posts
              this.noPostsEl.style.display = 'none'
          }
  
  
      }
  
      storePostHtml() {
          // Store allPostHtml ---
          let filter = this
  
          let posts = document.querySelectorAll(`.${this.container} .${this.item}`);
  
          posts.forEach((el, i) => {
              let id = el.getAttribute(`${filter.itemID}`)
              filter.allPostHtml[id] = el;
          })
  
          this.currentPostHtml = this.allPostHtml;
      
          window.log("HTML:", this.currentPostHtml)
      }
  
  
      buildFiltersFunction() {
          // Build filters ---
          let filter_html = '';
          Object.keys(this.filterSettings).forEach((theme, i) => {
  
              // window.log("type", typeof this.filterSettings[theme])
              // window.log("settings", this.filterSettings[theme])
              // window.log("theme", theme)
  
              if(this.filterSettings[theme].length > 0 && !this.ignoreFilters.includes(theme)){
  
                  filter_html += `
                                  <div class="custom-filter" data-theme="${theme}" style="display: flex; flex-direction: column">
                                      <p class="filter-heading d-flex justify-content-between align-items-center" style="text-transform: capitalize">
                                          ${theme}
  
                                          <svg xmlns="http://www.w3.org/2000/svg" width="15.403" height="8.806" viewBox="0 0 15.403 8.806">
                                              <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M6.152,7.7.323,1.876A1.1,1.1,0,0,1,1.882.322l6.6,6.6a1.1,1.1,0,0,1,.032,1.518L1.887,15.082A1.1,1.1,0,0,1,.328,13.528Z" transform="translate(15.403) rotate(90)" fill="#10573b" />
                                          </svg>
  
                                      </p>
                                      <div class="filter-body">
                                  `;
  
                  let terms = this.filterSettings[theme]
                  terms.forEach((term) => {
                      filter_html += `
                                      <label>
                                          <input type="checkbox" data-theme="${theme}" data-term="${term}" >
                                          ${term}
                                      </label>`;
                  })
  
                  filter_html += `    </div>
                                  </div>`;
              }
          })
  
          // Add filter container if none exists
          if(!this.filterContainerEl){
  
              let filterContainer = document.createElement('div')
              filterContainer.classList.add(this.filterContainer)
              filterContainer.style.display = 'flex'
              this.containerEl.parentNode.insertBefore(filterContainer, this.containerEl)
  
              this.filterContainerEl = filterContainer
          }
  
          // Add filters to container
          this.filterContainerEl.append(this.htmlToElement(filter_html))
  
      }
  
      setUpListeners() {
  
          let filter = this
  
          // Listen for filter option changes ---
          let filterCheckboxes = document.querySelectorAll(`.custom-filter input[type=checkbox]`)
					const isPickNMixPage = document.getElementsByClassName('pick-n-mix-container').length
	
					filterCheckboxes.forEach((el) => {
  
              el.addEventListener('change', () => {
                  let checked = el.checked;
  
                  let theme = el.getAttribute("data-theme")
                  let term = el.getAttribute("data-term")
                  
                  window.log("THEME:", theme)
                  window.log("TERM:", term)
  
                  // START Knicker picker specific ---
                  if(theme =='size' || theme == 'picknmixType'){
                      let label = el.parentNode;
                      let siblings = label.parentNode.querySelectorAll('label')
                      // Unset other size options
                      siblings.forEach((label) => {
                          // remove style
                          label.classList.remove('active')
                          // uncheck input
                          let input = label.querySelector('input')
                          let input_term = input.getAttribute("data-term")
													if (input_term !== term || isPickNMixPage) {
														input.checked = false;
													}
                          // Remove from filter options if exists
                          if(filter.filterOptions[theme] && filter.filterOptions[theme].includes(input_term)){
                              let index = filter.filterOptions[theme].indexOf(input_term);
                              if (index > -1) {
                                  filter.filterOptions[theme].splice(index, 1);
                                  // filterOptionsCount--
                              }
                          }
                      })
                      if(checked){
                          label.classList.add('active')
                          // Save user choice
                          if(theme == 'size'){
                              localStorage.setItem('s&s:pick-n-mix:size', JSON.stringify(term.replaceAll('"', '')));
                          }
                      } else {
                          label.classList.remove('active')
                      }
                  } else if (theme == 'color' || theme == 'pattern') {
                      let label = el.parentNode.parentNode;
                      label.classList.toggle('active')
                  }
                  // END Knicker picker specific ---
  
  
                  if(checked){
                    if(!filter.filterOptions.hasOwnProperty(theme)){
                        filter.filterOptions[theme] = [];
                    }

                    if (term.indexOf(';') > -1) {
                      var splittedTerm = term.split(';');
  
                      for (var i = 0; i < splittedTerm.length; i++) {
                          filter.filterOptions[theme].push(splittedTerm[i]);
                      }
                    } else {
                      filter.filterOptions[theme].push(term);
                    }
    
                    // filterOptionsCount++
                } else {
                    if (term.indexOf(';') > -1) {
                      var splittedTerm = term.split(';');
  
                      for (var i = 0; i < splittedTerm.length; i++) {
                        let index = filter.filterOptions[theme].indexOf(splittedTerm[i]);
                        if (index > -1) {
                            filter.filterOptions[theme].splice(index, 1);
                            // filterOptionsCount--
                        }     
                      }
                    } else {
                        let index = filter.filterOptions[theme].indexOf(term);
                        if (index > -1) {
                            filter.filterOptions[theme].splice(index, 1);
                            // filterOptionsCount--
                        } 
                    }
                }
      
                  window.log("Filter Options:", filter.filterOptions)
                  filter.showPosts()
  
              })
  
  
          })
  
          if(this.loadMoreEl){
              // Load More ---
              this.loadMoreEl.addEventListener('click', () => {
                  filter.postsToShow += filter.loadMoretoShow;
                  filter.showPosts();
              });

              window.addEventListener('scroll', (e) => {
                  const rect = this.loadMoreEl.getBoundingClientRect(), viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                  if( !(rect.bottom < 0 || rect.top - viewHeight >= 0) ) {
                      this.loadMoreEl.click();
                  }
              });
          }
  
  
          // Sort
          if(this.sortContainerEl){
              let sort_select = document.querySelector(`.${this.sortContainer} select`)
  
              sort_select.addEventListener('change', () => {
                  let sortMethod = sort_select.value
                  if(this.allowedSortMethods.includes(sortMethod)){
                      this.sortMethod = sortMethod
                      filter.showPosts()
  
                  } else {
                      window.log(`${sortMethod} is not a vaild sort option`)
                  }
              })
          }
          
          // Price Range
          let rangeInputs = document.querySelectorAll(".range-input input")
          rangeInputs.forEach((input) => {
              input.addEventListener("input", e =>{
                  let minPrice = parseInt(rangeInputs[0].value);
                  let maxPrice = parseInt(rangeInputs[1].value);
      
                  
                  filter.minPrice = minPrice * 100
                  filter.maxPrice = maxPrice * 100
                  
              });
          })
  
  
          // Apply Price range - (price range will be used next time filter options are change. This listener filters when the apply button is pressed)
          let applyPriceBtn = document.querySelector('#applyPriceRange')
          if(applyPriceBtn){
              applyPriceBtn.addEventListener('click', () => {
                  filter.showPosts()
              })
          }
  
  
      
      }
  
      getPosts(){
  
          // Show all if if no filter options have been selected
          var filterOptionsCount = 0;
          for(let key in this.filterOptions){
              filterOptionsCount += this.filterOptions[key].length;
          }
  
          if(filterOptionsCount == 0 && (this.minPrice == this.defaultMinPrice && this.maxPrice == this.defaultMaxPrice)){
              return this.allPostHtml;
          } else {
              return this.filterPosts();
          }
  
      }
  
      filterPosts(){
  
          // find posts that match filter options
          let filtered_posts = [];
  
           window.log("FILTER OPTIONS: ", this.filterOptions)
  
          for(let key in this.postData){
              
              if(this.inPriceRange(key)){
                  // window.log(">",key)
                  
                  let found = true;
  
                  for(let theme in this.postData[key]){
                      let terms = this.postData[key][theme]
                      if(this.postData[key].title == 'Knicker - Celestial' && theme == 'size') {
                          window.log('terms',terms);
                          window.log('theme',theme);
                          //window.log('ls',this.postData[key].variants['M']);
                      }
                      
                      if(terms && this.filterOptions.hasOwnProperty(theme) && this.filterOptions[theme].length > 0){
                          found = this.filterOptions[theme].some(el => terms.indexOf(el) >= 0)
                      }
  
                     
  
                      if(theme == 'size') {
                          // if(this.filterOptions.hasOwnProperty(theme) && this.filterOptions[theme].length > 0 && this.postData[key].variants[this.filterOptions[theme]]) {
                              window.log(this.filterOptions[theme]);
                          // }
                      }
                      
                      
                      if(!found){
                          break;
                      }
                  }
              
                  if(found){
                      filtered_posts.push(key)
                  }
              }
  
          
          }
  
          window.log("FILTERED: ", filtered_posts, "Length: ", filtered_posts.length)
  
          let filteredPostHtml = {};
  
          filtered_posts.forEach(postId => {
              filteredPostHtml[postId] = this.allPostHtml[postId];
          });
  
          return filteredPostHtml;
          
      }
  
      inPriceRange(product_id){
          let price = this.postData[product_id].price
          return ((this.minPrice < price) && (price < this.maxPrice))
      }
  
      urlFilters(){
  
          let queryString = window.location.search;
  
          if(queryString != ''){
              let queryParts = queryString.substring(1).split('&')
              let urlQuery = {}
      
              queryParts.forEach((part) => {
                  let themeQuery = part.split('=')
                  let searchTheme  = themeQuery[0];
                  let searchTerms  = themeQuery[1].split('+');
                  searchTerms = searchTerms.map((term) => {
                      return decodeURIComponent(term)
                  })
      
                  urlQuery[searchTheme] = searchTerms
      
                 
              })
              
              //window.log("FILTER SETTINGS", this.filterSettings)
              //window.log("URL Query", urlQuery)
      
      
              for(let theme in this.filterSettings){
      
                  let searchTerms = Object.keys(urlQuery).includes(theme) ? urlQuery[theme] : null
      
                  if(searchTerms){
      
                      searchTerms.forEach((term) => {
      
                          // if term is a valid setting, add to options
                          let termsForTheme = this.filterSettings[theme]
      
                          window.log("term", term, termsForTheme)
      
      
                          if(Object.values(termsForTheme).includes(term)){
      
                              // init as array if not yet defined
                              if(!this.filterOptions[theme]){
                                  this.filterOptions[theme] = [];
                              }
      
                              // Add term to filter options
                              this.filterOptions[theme].push(term)
      
                              // check relevant checkbox
                              let termInput = document.querySelector(`[data-theme="${theme}"][data-term="${term}"]`)
                              termInput.checked = true
  
  
                              // STRIPE AND STARE SPECIFIC
                              if(theme =='size'){
                                  let label = termInput.parentNode;
                                  label.classList.add('active')
                              }
      
      
                          }
      
                      })
      
                  }
      
              }
  
              //window.log("FILTER OPTIONS", this.filterOptions)
  
      
          }
  
  
  
          
      }
  
      setUrlParams(){
  
          if(Object.keys(this.filterOptions).length > 0){
              let searchParams = '?'
  
              // window.log("OPT:", this.filterOptions)
  
              for(let theme in this.filterOptions){
                  searchParams = searchParams + `${theme}=`
                  let terms = this.filterOptions[theme]
                  terms = terms.map((term) => {
                      return encodeURIComponent(term)
                  })
                  // window.log(">terms", terms)
                  terms = terms.join('+')
                  // window.log(">>terms", terms)
                  // terms = encodeURI(terms)
                  // window.log(">>>terms", terms)
  
                  searchParams = searchParams + terms + "&"
                  
              }
  
              searchParams = searchParams.substring(0, searchParams.length - 1)
              // window.log("NEW PARAMS:", searchParams)
      
              var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + searchParams;
              window.history.pushState({path:newurl},'',newurl);
          }
  
      }
    
    showPosts(){
  
        window.log("SHOWING POSTS")
        
        // Set currentPostHtml
        let postHtml = this.getPosts()
        this.currentPostHtml = postHtml;
  
  
  
        this.clearPosts();
  
        let postsAdded = 0;
        let i = 0;
  
        if(this.sortMethod != 'default'){

            let sortOrder = this.sortPosts(postHtml);
            for(let i = 0; i < sortOrder.length; i++){
              
              // show advert
              if(i == 4 && this.advertHtml){
                  this.containerEl.append(this.advertHtml)
              }

              // show advert video
              if(i == 1 && this.advertHtmlVIdeo){
                  this.containerEl.append(this.advertHtmlVIdeo)
              }
  
              this.containerEl.append(postHtml[sortOrder[i]])
              postsAdded++
  
              if(postsAdded >= this.postsToShow){ break; }
  
            }
  
        } else {
  
            let productIds = Object.keys(postHtml)
            for(let i = 0; i < productIds.length; i++){
  
              // show advert
              if(i == 4 && this.advertHtml){
                  this.containerEl.append(this.advertHtml)
              }

              // show advert video
              if(i == 1 && this.advertHtmlVIdeo){
                  this.containerEl.append(this.advertHtmlVIdeo)
              }
  
              this.containerEl.append(postHtml[productIds[i]])
              postsAdded++
  
              if(postsAdded >= this.postsToShow){ break; }
            }
  
        }
  
        // Show/Hide no posts message
        if(postsAdded == 0){
            this.noPostsEl.style.display = 'block'
        } else {
            this.noPostsEl.style.display = 'none'
        }
        
  
        // Show/Hide load more
        let totalPostCount = Object.keys(postHtml).length;
  
        if(this.loadMoreEl){
          if(totalPostCount <= this.postsToShow){
              this.loadMoreEl.style.display = 'none'
          } else {
              this.loadMoreEl.style.display = 'block'
          }
        }
        
        this.setUrlParams()
        
        return postHtml
    }
  
    sortPosts(postHtml){
        // window.log("SORTING")
  
        let sortOrder = Object.keys(postHtml);
  
        // window.log("ORDER BEFORE", sortOrder)
  
        switch(this.sortMethod){
            case 'published_at_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['published_at'] - this.postData[b]['published_at'];
                })
                break;
  
            case 'published_at_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['published_at'] - this.postData[a]['published_at'];
                })
            break;
  
            case 'price_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['price'] - this.postData[b]['price'];
                })
                break;
  
            case 'price_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['price'] - this.postData[a]['price'];
                })
                break;
  
            case 'title_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['title'].localeCompare(this.postData[b]['title']);
                })
                break;
  
            case 'title_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['title'].localeCompare(this.postData[a]['title']);
                })
                break;
  
            // case 'favourites':
            //     sortOrder.sort(function(a,b){
            //         return this.postData[b]['is_favourite'] - this.postData[a]['is_favourite'];
            //     })
            //     break;
  
            // case 'collab':
            //     sortOrder.sort(function(a,b){
            //         return this.postData[b]['is_collab'] - this.postData[a]['is_collab'];
            //     })
            //     break;
        }
  
        // window.log("ORDER AFTER", sortOrder)
  
        return sortOrder;
    }

    setAdvertVideo() {
		let advertHtmlVIdeo = document.querySelector('#collection-advert-video')
		if(advertHtmlVIdeo){
			this.advertHtmlVIdeo = advertHtmlVIdeo
			advertHtmlVIdeo.parentNode.removeChild(advertHtmlVIdeo)
		} else {
			if(this.loadMoreEl){
				this.postsToShow = 12;
			}
		}
	}
  
    setAdvert(){
      let advertHtml = document.querySelector('#collection-advert')
      if(advertHtml){
          this.advertHtml = advertHtml
          advertHtml.parentNode.removeChild(advertHtml)
          //window.log("ADVERT HTML", advertHtml)
      } else {
        if(this.loadMoreEl){
          this.postsToShow = 12;
        }
          //window.log("NO ADVERT HTML")
      }
  
    }
  
    // HELPER FUNCITONS
  
    // Takes an html sting and returns it as an element
    htmlToElement(html) {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content;
    }
  
  
    // PUBLIC FUNCTIONS
    clearPosts(){
        let posts = document.querySelectorAll(`.${this.container} .${this.item}`);
  
        posts.forEach((el, i) => {
            el.parentNode.removeChild(el)
        })
  
    }
  
  }
